<template>
  <div>
    <div
        v-if="adMobLoading"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>

    <v-container class="padding_10" fluid grid-list-md v-else>
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg12 style="display:flex; justify-content: flex-end;">
          <v-btn color="info" :to="{name: 'adSchedules'}">Dynamic Scheduling</v-btn>
        </v-flex>
        <v-flex xm12 sm12 md12 lg12>
          <v-card>
            <v-card-title class="headline">AdMob Labels</v-card-title>
            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Banner:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Banner Id"
                        v-model="labels.banner.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Banner Id"
                        v-model="labels.banner.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.banner.android, labels.banner.iOS, 'banner')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Large Banner:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Large Banner Id"
                        v-model="labels.large_banner.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Large Banner Id"
                        v-model="labels.large_banner.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.large_banner.android, labels.large_banner.iOS, 'large_banner')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Medium Rectangle:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Medium Rectangle"
                        v-model="labels.medium_rectangle.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Medium Rectangle"
                        v-model="labels.medium_rectangle.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.medium_rectangle.android, labels.medium_rectangle.iOS, 'medium_rectangle')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Interstitial: </v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Interstitial"
                        v-model="labels.interstitial.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Interstitial"
                        v-model="labels.interstitial.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.interstitial.android, labels.interstitial.iOS, 'interstitial')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Rewarded Interstitial:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Rewarded Interstitial"
                        v-model="labels.rewarded_interstitial.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="iOS Rewarded Interstitial"
                        v-model="labels.rewarded_interstitial.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.rewarded_interstitial.android, labels.rewarded_interstitial.iOS, 'rewarded_interstitial')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Native:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Native"
                        v-model="labels.native.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Native"
                        v-model="labels.native.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.native.android, labels.native.iOS, 'native')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>App Open:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android App Open"
                        v-model="labels.app_open.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS App Open"
                        v-model="labels.app_open.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.app_open.android, labels.app_open.iOS, 'app_open')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>

            <form>
              <v-flex xs12 sm12 md12 lg12
                      style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;
                      justify-content: center; align-content: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Rewarded:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="Android Rewarded"
                        v-model="labels.rewarded.android"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 lg5>
                    <v-text-field
                        label="IOS Rewarded"
                        v-model="labels.rewarded.iOS"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md2 lg2 style="display: flex;justify-content: flex-end;align-items: center;">
                    <v-btn color="success" @click="submitAbMobData(labels.rewarded.android, labels.rewarded.iOS, 'rewarded')">
                      Submit
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>


</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      labels: {
        banner: {
          android: null,
          iOS: null
        },
        rewarded_interstitial: {
          android: null,
          iOS: null
        },
        native: {
          android: null,
          iOS: null
        },
        app_open: {
          android: null,
          iOS: null
        },
        rewarded: {
          android: null,
          iOS: null
        },
        large_banner: {
          android: null,
          iOS: null
        },
        medium_rectangle: {
          android: null,
          iOS: null
        },
        interstitial: {
          android: null,
          iOS: null
        }
      },
      adMob_android_data: [],
      adMob_ios_data: [],
      adMobLoading: false,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
    }
  },
  methods: {
    getMobData() {
      this.startLoading()
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-admob-labels`, {headers:this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.adMob_android_data = response.data.android;
          this.adMob_ios_data = response.data.ios;

          this.adMob_android_data.forEach((item) => {
            if(item.name == 'banner'){
              this.labels.banner.android = item.adUnit_id;
            }else if(item.name =='large_banner'){ this.labels.large_banner.android = item.adUnit_id; }
            else if(item.name =='medium_rectangle'){this.labels.medium_rectangle.android = item.adUnit_id;}
            else if(item.name =='interstitial'){this.labels.interstitial.android = item.adUnit_id;}
            else if(item.name =='rewarded_interstitial'){this.labels.rewarded_interstitial.android = item.adUnit_id;}
            else if(item.name =='native'){this.labels.native.android = item.adUnit_id;}
            else if(item.name =='app_open'){this.labels.app_open.android = item.adUnit_id;}
            else if(item.name =='rewarded'){this.labels.rewarded.android = item.adUnit_id;}
          });

          this.adMob_ios_data.forEach((item) =>{
            if(item.name == 'banner'){
              this.labels.banner.iOS = item.adUnit_id;
            }else if(item.name =='large_banner'){ this.labels.large_banner.iOS = item.adUnit_id; }
            else if(item.name =='medium_rectangle'){this.labels.medium_rectangle.iOS = item.adUnit_id;}
            else if(item.name =='interstitial'){this.labels.interstitial.iOS = item.adUnit_id;}
            else if(item.name =='rewarded_interstitial'){this.labels.rewarded_interstitial.iOS = item.adUnit_id;}
            else if(item.name =='native'){this.labels.native.iOS = item.adUnit_id;}
            else if(item.name =='app_open'){this.labels.app_open.iOS = item.adUnit_id;}
            else if(item.name =='rewarded'){this.labels.rewarded.iOS = item.adUnit_id;}
          });

          // this.labels.large_banner.android = this.adMob_android_data.large_banner;
          // this.labels.large_banner.iOS = this.adMob_ios_data.large_banner;
          //
          // this.labels.medium_rectangle.android = this.adMob_android_data.medium_rectangle;
          // this.labels.medium_rectangle.iOS = this.adMob_ios_data.medium_rectangle;
          //
          // this.labels.interstitial.android = this.adMob_android_data.interstitial;
          // this.labels.interstitial.iOS = this.adMob_ios_data.interstitial;
          //
          // this.labels.rewarded_interstitial.android = this.adMob_android_data.rewarded_interstitial;
          // this.labels.rewarded_interstitial.iOS = this.adMob_ios_data.rewarded_interstitial;
          //
          // this.labels.native.android = this.adMob_android_data.native;
          // this.labels.native.iOS = this.adMob_ios_data.native;
          //
          // this.labels.app_open.android = this.adMob_android_data.app_open;
          // this.labels.app_open.iOS = this.adMob_ios_data.app_open;
          //
          // this.labels.rewarded.android = this.adMob_android_data.rewarded;
          // this.labels.rewarded.iOS = this.adMob_ios_data.rewarded;

          this.previousLabels = JSON.parse(JSON.stringify(this.labels));

          this.stopLoading();
        }
      });
    },
    submitAbMobData(android, iOS, type) {

      let formData = new FormData();
      formData.append('android', android);
      formData.append('iOS', iOS);
      formData.append('type', type);

      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/store-ad-mob-lables`, formData, {headers:this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.getMobData();
            } else if (response.data.status == 0) {
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          }).catch((error) => {
        console.warn(error);
        this.stopLoading();
        this.snackbar.message = "Error Occurred"
        this.snackbar.display = true;
      });
    }
  },
  mounted() {
    this.getMobData();
  }
}
</script>

<style scoped>

</style>
